export default "__VITE_ASSET__BlU8Oxx9__"